import { render, staticRenderFns } from "./companyLogin.vue?vue&type=template&id=3c5dfcdc&"
import script from "./companyLogin.vue?vue&type=script&lang=js&"
export * from "./companyLogin.vue?vue&type=script&lang=js&"
import style0 from "./companyLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports